import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { CreateTeamsSettings, DeleteTeamsSettings } from "../types"

export const teamsSettingsMutators = {
	create: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: CreateTeamsSettings }) => {
			const [existing] = await tx.query.teamsSettings
				.where("workspaceId", "=", args.workspaceId)
				.run()

			if (existing) {
				throw new Error("Teams settings already exist for this workspace")
			}

			await tx.mutate.teamsSettings.insert({
				id: args.id,
				workspaceId: args.workspaceId,
				tenantId: args.tenantId,
				createdAt: Date.now(),
				updatedAt: Date.now(),
			})
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteTeamsSettings }) => {
			await tx.mutate.teamsSettings.delete({ id: args.id })
		},
	),
}
